import script from "./Navbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Navbar.vue?vue&type=script&setup=true&lang=ts"

import "./Navbar.vue?vue&type=style&index=0&id=203b4fdc&lang=less&scoped=true"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-203b4fdc"]])

export default __exports__